@use "@sass/helper";

.formFields {
  position: relative;
}

.waiting {
  filter: blur(2px);
}

.overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  background-color: helper.$light;
  opacity: 80%;
}